const inspectionDetailStyle = {
  verticalGap: {
    marginTop: "20px"
  },
  verticalGap16: {
    marginTop: "16px"
  },
  smallFont: {
    fontSize: "14px"
  },

  normalWidth: {
    width: "80%"
  },
  fullWidth: {
    width: "100%"
  },
  longTextField: {
    width: "100%",
    "& .MuiInput-underline:before": {
      border: "none"
    },
    "& .MuiInputBase-input": {
      backgroundColor: "#f4f4f4",
      padding: "16px",
      fontSize: "14px"
    }
  },
  longTextMultiField: {
    "& .MuiInput-root": {
      minHeight: "127px",
      backgroundColor: "#f4f4f4"
    },
    marginTop: "20px",
    width: "100%"
  },
  textValueLabel: {
    backgroundColor: "#f4f4f4",
    "& .MuiNativeSelect-select": {
      fontSize: "14px",
      paddingLeft: "10px",
      lineHeight: "16.88px"
    }
  },
  leftWrapper: {
    paddingBottom: "10px !important"
  },
  leftBorder: {
    width: "100%",
    borderBottom: "1px solid #e0e0e0",
    paddingBottom: "20px"
  },
  img: {
    height: "177.22px",
    width: "93%",
    backgroundSize: "100% auto",
    borderRadius: "10px"
  },
  removePadding: {
    padding: "0px !important"
  },
  detailSession: {
    fontSize: "14px",
    lineHeight: "18px",
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "normal",
    color: "rgba(0, 0, 0, 0.87)"
  },
  warningAlertWrapper: {
    marginBottom: "8px"
  },
  imageDropWrapper: {
    width: "94%",
    height: "178px",
    "& .MuiDropzoneArea-text": {
      fontSize: "18px"
    },
    "& .MuiDropzoneArea-root": {
      minHeight: "0px",
      height: "inherit"
    }
  }
};

export default inspectionDetailStyle;
